// extracted by mini-css-extract-plugin
export default {"dropdown":"SearchContainer_dropdown__bM1QF","no_result":"SearchContainer_no_result__cNhYJ"};